module.exports = __webpack_public_path__ + "img/bedroom-bedding.ba529ea.jpg";